export default __webpack_public_path__ + "static/Entenda0123-7780f265209efc04c20fc1adda5fcb1d.jpg";